import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { IStreamData } from "@formant/core/model/IStreamData";
import { Uuid } from "@formant/core/model/Uuid";

import { DeviceSelector } from "../../common/DeviceSelector";
import { DeviceTags } from "../../common/DeviceTags";
import { ModuleFooter } from "../ModuleFooter";
import { currentByDevice } from "../utils/currentByDevice";
import * as styles from "./DeviceView.scss";
import { ImageView } from "./ImageView";

export interface IDeviceViewProps {
    data: IStreamData<"image">[];
    time: Date;
    hovering?: boolean;
    fullscreen?: boolean;
}

@observer
export class DeviceView extends Component<IDeviceViewProps> {
    @observable
    private selectedDeviceId?: Uuid;

    public render() {
        const { selectedDeviceId, onSelectDevice } = this;
        const { data, time, hovering, fullscreen } = this.props;

        const current = currentByDevice(data, time);

        const active = current.find(
            ({ deviceId }) => selectedDeviceId === deviceId,
        );

        const deviceIds = current.map(_ => _.deviceId);

        const url = active?.value.url;
        const annotations = active?.value.annotations;

        return (
            <div className={styles["device-view"]}>
                <div className={styles.main}>
                    <div className={styles.view}>
                        <ImageView src={url} annotations={annotations} />
                    </div>
                </div>
                <ModuleFooter visible={hovering} floating={true}>
                    {active && selectedDeviceId && (
                        <DeviceTags
                            deviceId={selectedDeviceId}
                            tags={active.tags}
                            time={active.time}
                        />
                    )}
                    <DeviceSelector
                        selected={selectedDeviceId}
                        deviceIds={deviceIds}
                        onSelect={onSelectDevice}
                        fullscreen={fullscreen}
                    />
                </ModuleFooter>
            </div>
        );
    }

    private onSelectDevice = (deviceId: Uuid) => {
        this.selectedDeviceId = deviceId;
    };
}
